import { saveAs } from 'file-saver';

export default class ExcelDownload {
    // payload = {
    //     name: 'carros'   
    //     header: ['cor', 'ano', 'marca', 'modelo'],
    //     body: [
    //         ['azul', '2017', 'honda', 'civic'],
    //         ['laranja', '2005', 'ford', 'fiesta'],
    //         ['preto', '2022', 'fiat', 'fastback'],
    //     ]
    // }
    // excel:
    // cor    | ano   | marca   | modelo 
    // azul   | 2017  | honda   | civic 
    // laranja| 2005  | ford    | fiesta 
    // preto  | 2022  | fiat    | fastback

    constructor(payload) {
        const XLSX = require('sheetjs-style');
        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "SheetJS",
            Subject: "Valores",
            Author: "Club da Cotação",
            CreatedDate: new Date()
        };
        wb.SheetNames.push('Produtos');
        var ws_data = [['Código', 'Descrição', 'Tip Emb.', 'Qtd Emb', 'Estoque', 'Estoq. Sug.', 'Sugestão', 'Pedido', 'categoria'], ...payload]; 
        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws["!cols"] = [ { wch: 10 }, { wch: 60 }, { wch: 20 }, { wch: 10 },{ wch: 10 },{ wch: 10 },{ wch: 10 },{ wch: 10 },{ wch: 15 }]
        const header = {
            font: {
                bold: true,
                italic: true
            },
            fill:{
                fgColor: { rgb: "9bbb59" }
            },
            border:{
                bottom: {style: 'thin', color: '737272'},
                right: {style: 'thin', color: '737272'},
            }
        }
        const order = {
            fill:{
                fgColor: { rgb: "ffff00" }
            },
            border:{
                bottom: {style: 'thin', color: '737272'},
                right: {style: 'thin', color: '737272'},
                left: {style: 'thin', color: '737272'},
            }
        }
        ws["A1"].s = header
        ws["B1"].s = header
        ws["C1"].s = header
        ws["D1"].s = header
        ws["E1"].s = header
        ws["F1"].s = header
        ws["G1"].s = header
        ws["H1"].s = header
        ws["I1"].s = header

        for (let index = 2; index < 5000; index++) {
            if(ws["H"+index]) ws["H"+index].s = order
            else break;
        }
        
        wb.Sheets['Produtos'] = ws;

        wb.SheetNames.push('Produtos 2');
        ws_data = [['Código', 'Descrição', 'Tip Emb.', 'Qtd Emb', 'Estoque', 'Estoq. Sug.', 'Sugestão', 'Pedido', 'categoria']]; 
        ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws["!cols"] = [ { wch: 10 }, { wch: 60 }, { wch: 20 }, { wch: 10 },{ wch: 10 },{ wch: 10 },{ wch: 10 },{ wch: 10 },{ wch: 15 }]
        ws["A1"].s = header
        ws["B1"].s = header
        ws["C1"].s = header
        ws["D1"].s = header
        ws["E1"].s = header
        ws["F1"].s = header
        ws["G1"].s = header
        ws["H1"].s = header
        ws["I1"].s = header
        wb.Sheets['Produtos 2'] = ws;


        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
        saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), 'Produtos' + '.xlsx');
    }
}